import { Base64 } from "js-base64";
import { i18n } from "@/locale/i18n";
import appConfig from "@/config/application";
import UserProvider from "@/services/user_provider";
import router from "../../router";

const userProvider = new UserProvider();

const state = {
  theme: 0,
  showPreLoader: false,
  showError: false,
  errorText: "",
  showErrorTemp: false,
  errorTextTemp: "",
  isExpiredTemp: false,
  isExpired: false,
  isQue: false,
  redirectPage: "",
  token: "",
  sessionguid: "",
  seq: "",
  userId: 0,
  userMfuUserId: 0,
  userInfo: {
    data: {},
    currentLocale: appConfig.currentLocale,
    menus: [],
    currentMainMenu: {
      th: "",
      en: ""
    },
    currentMenu: {
      id: 0,
      name: ""
    }
  },
  studentInfo: {
    studentId: 0,
    data: {},
    menus: []
  }
};

const mutations = {
  INIT_APPLICATION(state) {
    let jwt = state.token;
    if (jwt !== null) {
      let userinfo = JSON.parse(atob(jwt.split(".")[1])).user_claims.data;
      if (userinfo.usertype === 10) {
        state.userId = userinfo.userid;
      } else {
        state.userId = userinfo.misuserid;
      }
      state.userMfuUserId = userinfo.userid;
    } else {
      state.token = "";
      state.userId = 0;
    }
    state.userInfo.currentLocale = appConfig.currentLocale;
    state.userInfo.currentMainMenu = {
      th: "ข้อมูลปัจจุบันในระบบ",
      en: "ข้อมูลปัจจุบันในระบบ(EN)"
    };
    state.userInfo.currentMenu = {
      id: 0,
      name: "หน้าหลัก"
    };
    state.isExpired = false;
    state.isExpiredTemp = false;
  },
  SET_CURRENT_LOCATE(state) {
    const newLocale = state.userInfo.currentLocale == "th" ? "en" : "th";
    state.userInfo.currentLocale = newLocale;
    i18n.locale = newLocale;
  },
  SET_CURRENT_MENU(state, payload) {
    state.userInfo.currentMainMenu = payload.mainMenu;
    state.userInfo.currentMenu = payload.menu;
  },
  TOGGLE_PRELOADER(state, payload) {
    const storage = JSON.parse(localStorage.getItem("mfu-er-app"));
    if (storage != null) {
      if (storage.application.isExpiredTemp || storage.application.isExpired) {
        state.token = "";
        state.isExpired = true;
        router.push("/redirecthome");
      }
      if (storage.application.showErrorTemp) {
        state.showError = true;
        state.errorText = storage.application.errorTextTemp;

        state.showErrorTemp = false;
        state.errorTextTemp = "";
      } else {
        state.showError = false;
        state.errorText = "";
      }
    }
    const currentLocale =
      state.userInfo.currentLocale === undefined ||
      state.userInfo.currentLocale === ""
        ? "th"
        : state.userInfo.currentLocale;
    if (currentLocale != i18n.locale) {
      i18n.locale = currentLocale;
    }
    state.showPreLoader = payload;
  },
  SET_TOKEN(state, payload) {
    state.token = payload;
    // state.isExpired = !payload;
    state.showError = false;
    state.errorText = "";
  },
  SET_QUE_TOKEN(state, payload) {
    state.token = payload;
    state.isExpired = false;
    state.isExpiredTemp = false;
    state.userId = 0;
    state.userInfo.data = false;
    state.userInfo.menus = false;
    state.showError = false;
    state.isQue = true;
    state.errorText = "";
  },
  SET_MENU(state, payload) {
    state.userInfo.menus = payload;
  },
  SET_CURRENT_USER(state, payload) {
    state.userInfo.data = payload;
  },
  SET_SESSION_GUID(state, payload) {
    state.sessionguid = payload;
  },
  SET_SEQ(state, payload) {
    state.seq = payload;
  },
  LOGOUT(state) {
    state.token = "";
    state.userId = 0;
    state.userInfo.data = false;
    state.userInfo.menus = false;
    state.isExpired = true;
    router.push("/redirecthome");
  },
  CLEAR_TOKEN(state) {
    state.token = "";
    state.userId = 0;
    state.userInfo.data = false;
    state.userInfo.menus = false;
    state.isExpired = true;
  },
  SWITCH_THEME(state, payload) {
    state.theme = payload;
  },
  TOGGLE_SIDEBAR() {
    var currentClass = document.getElementsByTagName("body")[0].className;
    document.getElementsByTagName("body")[0].className =
      currentClass === "sidebar-mini" ? "sidebar-show" : "sidebar-mini";
  },
  TOKEN_HEALTHCHK(state) {
    const storage = JSON.parse(localStorage.getItem("mfu-er-app"));
    if (storage != null) {
      if (storage.application.isExpiredTemp || storage.application.isExpired) {
        state.token = "";
        state.isExpired = true;
        router.push("/redirecthome");
      }
      if (storage.application.showErrorTemp) {
        state.showError = true;
        state.errorText = storage.application.errorTextTemp;

        state.showErrorTemp = false;
        state.errorTextTemp = "";
      } else {
        state.showError = false;
        state.errorText = "";
      }
    }
  },
  SET_ERROR_POPUP(state, payload) {
    state.showError = payload;
    if (!payload) {
      state.errorText = "";
    }
  },
  SET_REDIRECT_PAGE(state, payload) {
    state.redirectPage = payload;
  },
  SET_STUDENT_INFO(state, payload) {
    state.studentInfo = payload;
  },
  CLEAR_STUDENT_INFO(state) {
    state.studentInfo = {
      studentId: 0,
      data: {},
      menus: []
    };
  },
  SET_RELOAD(state, payload) {
    if (payload > 0) {
      state.reload = new Date();
    } else {
      state.reload = payload;
    }
  },
  SET_DATATRANSFER(state, payload) {
    let token = payload.token;
    let menus = payload.menus;

    // setMenu
    state.userInfo.menus = menus;

    // initApplication
    let userinfo = state.userInfo.data;
    if (userinfo.USER_TYPE === "S") {
      state.userId = payload.userid;
    } else {
      state.userId = payload.misuserid;
    }
    state.userMfuUserId = userinfo.USERID;

    state.userInfo.currentLocale = appConfig.currentLocale;
    state.userInfo.currentMainMenu = {
      th: "ข้อมูลปัจจุบันในระบบ",
      en: "ข้อมูลปัจจุบันในระบบ(EN)"
    };
    state.userInfo.currentMenu = {
      id: 0,
      name: "หน้าหลัก"
    };

    // togglePreLoader
    state.showErrorTemp = false;
    state.errorTextTemp = "";
    state.showError = false;
    state.errorText = "";

    const currentLocale =
      state.userInfo.currentLocale === undefined ||
      state.userInfo.currentLocale === ""
        ? "th"
        : state.userInfo.currentLocale;
    if (currentLocale != i18n.locale) {
      i18n.locale = currentLocale;
    }
    state.showPreLoader = payload.showPreLoader;

    // setToken
    state.token = token;
    state.isExpired = false;
    state.isExpiredTemp = false;
    state.isQue = false;
  }
};

const actions = {
  async initApplication({ commit }) {
    commit("INIT_APPLICATION");
  },
  async setCurrentUserAsync({ commit }, payload) {
    const res = await userProvider.currentUser(payload);
    commit("SET_CURRENT_USER", res[0]);
  },
  setCurrentUser({ commit }, payload) {
    commit("SET_CURRENT_USER", payload);
  },
  setCurrentLocale({ commit }) {
    commit("SET_CURRENT_LOCATE");
  },
  setCurrentMenu({ commit }, payload) {
    commit("SET_CURRENT_MENU", payload);
  },
  togglePreLoader({ commit }, payload) {
    commit("TOGGLE_PRELOADER", payload);
  },
  setToken({ commit }, payload) {
    commit("SET_TOKEN", payload);
  },
  setQueToken({ commit }, payload) {
    commit("SET_QUE_TOKEN", payload);
  },
  setMenu({ commit }, payload) {
    commit("SET_MENU", payload);
  },
  setSessionGuid({ commit }, payload) {
    commit("SET_SESSION_GUID", payload);
  },
  setSeq({ commit }, payload) {
    commit("SET_SEQ", payload);
  },
  logout({ commit }) {
    commit("LOGOUT");
  },
  switchTheme({ commit }, payload) {
    commit("SWITCH_THEME", payload);
  },
  toggleSidebar({ commit }, payload) {
    commit("TOGGLE_SIDEBAR", payload);
  },
  tokenHealthChk({ commit }) {
    commit("TOKEN_HEALTHCHK");
  },
  setErrorPopup({ commit }, payload) {
    commit("SET_ERROR_POPUP", payload);
  },
  setRedirectPage({ commit }, payload) {
    commit("SET_REDIRECT_PAGE", payload);
  },
  clearToken({ commit }) {
    commit("CLEAR_TOKEN");
  },
  setStudentInfo({ commit }, payload) {
    commit("SET_STUDENT_INFO", payload);
  },
  clearStudentInfo({ commit }) {
    commit("CLEAR_STUDENT_INFO");
  },
  setReload({ commit }, payload) {
    commit("SET_RELOAD", payload);
  },
  setDatatransfer({ commit }, payload) {
    commit("SET_DATATRANSFER", payload);
  }
};

const getters = {
  getUserId: state => {
    return state.userId;
  },
  getUserInfo: state => {
    return state.userInfo;
  },
  displayPreLoader: state => {
    return state.showPreLoader;
  },
  isAuth: state => {
    return state.token != "" || !state.isExpired;
  },
  getToken: state => {
    return state.token;
  },
  getMenu: state => {
    return state.studentInfo.menus && state.studentInfo.menus.length > 0
      ? state.studentInfo.menus
      : state.userInfo.menus;
  },
  isExpired: state => {
    return state.isExpired;
  },
  getTheme: state => {
    return state.theme;
  },
  isError: state => {
    return state.showError;
  },
  getErrorText: state => {
    return state.errorText;
  },
  isRedirectStatement: state => {
    return Base64.decode(state.redirectPage) === "statement";
  },
  isQue: state => {
    return state.isQue;
  },
  getStudentInfo: state => {
    return state.studentInfo;
  },
  getStudentId: state => {
    return state.studentInfo.studentId;
  },
  getMfuUserId: state => {
    return state.userMfuUserId;
  },
  getReload: state => {
    return state.reload;
  },
  getSessionGuid: state => {
    return state.sessionguid;
  },
  getSeq: state => {
    return state.seq;
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};
